import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import reportWebVitals from './reportWebVitals';
import { REACT_APP_WEB3FORMS_ACCESS_KEY } from './config/emailEnv';

if (process.env.NODE_ENV === 'development' && !REACT_APP_WEB3FORMS_ACCESS_KEY) {
    console.warn(
        '[Landmarks Realty] REACT_APP_WEB3FORMS_ACCESS_KEY is empty. Use a .env or .env.local file next to package.json (same folder as package.json), then stop and restart npm start.'
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
